$(document).ready(function(){
  $('[data-toggle="tooltip"]').tooltip()
});


// WEBPACK FOOTER //
// ./src/pages/account/shipper/transfer-shipper-vouchers.js